export enum QueryParameterTypes {
    Value = 'value',
    Range = 'range',
}
